import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Gesture from "@material-ui/icons/Gesture";
import Build from "@material-ui/icons/Build";
import Edit from "@material-ui/icons/Edit"; // mode_edit yerine gerçek ikon

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.js";

const useStyles = makeStyles(servicesStyle);

export default function SectionServices() {
  const classes = useStyles();

  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>Tasarım ve Fonksiyonelliği Birleştiriyoruz</h2>
          <h5 className={classes.description}>
            Kisetsu olarak estetik, kalite ve kullanım kolaylığını bir araya getirerek hayatınızı daha planlı ve anlamlı kılacak ajandalar tasarlıyoruz.
          </h5>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="1. Özgün Tasarım"
            description="Her ajandamız, sizin stilinize ve ihtiyaçlarınıza hitap edecek şekilde titizlikle tasarlanır."
            icon={Gesture}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="2. Kaliteli Üretim"
            description="Kullanım ömrü uzun, kaliteli malzemelerle üretilen ajandalarımız sizi asla yarı yolda bırakmaz."
            icon={Build}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="3. Kişiselleştirme"
            description="Ajandanızı dilediğiniz gibi kişiselleştirin. Hayatınıza ve iş akışınıza uyum sağlasın."
            icon={Edit}
            iconColor="rose"
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
